import Vue from "vue";
import Vuex from "vuex";
import config from "./config";
import { adminAccountDetail } from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: config,
    user: {
      user: {},
      navigation: [],
    },
    currentPage: {
      title: '',
      url: '',
    },
  },
  getters: {},
  mutations: {
    updateUserInfo(state, user) {
      state.user = user;
    },
    updateCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
  },
  actions: {
    authInit({ commit }, _this) {
      const userInfoJson = _this.$localStorage.get("user");
      if (userInfoJson) {
        commit("updateUserInfo", JSON.parse(userInfoJson));
      }
      return new Promise((resolve) => {
        _this.$api.accountDetail()
          .then(userInfo => {
            commit("updateUserInfo", userInfo);
            _this.$localStorage.set("user", JSON.stringify(userInfo));
            resolve(userInfo);
          })
          .catch(() => {
            _this.$localStorage.remove("user");
            _this.$localStorage.remove("token");
            _this.$router.replace({ path: '/web/login' });
          })
      });
    },
  },
  modules: {},
});
